<template>
  <div>
    <h2 class="mb-4">Crear Nueva Sala de Cultivo</h2>
    <form @submit.prevent="submitForm" class="mb-4">
      <div v-if="club_id !== null && club" class="mb-3">
        <label for="nombreClub" class="form-label">Club:</label>
        <input v-model="club.nombre" type="text" class="form-control" id="nombreClub" disabled />
      </div>

      <div class="mb-3">
        <label for="tipo" class="form-label">Tipo:</label>
        <select v-model="sala.tipo" class="form-select" id="tipo" required>
          <option v-for="tipo in tiposSalas" :key="tipo" :value="tipo">{{ tipo }}</option> 
        </select>
      </div>

      <div class="mb-3">
        <label for="nombre" class="form-label">Nombre:</label>
        <input v-model="sala.nombre" type="text" class="form-control" id="nombre" required />
      </div>

      <div class="mb-3">
        <label for="descripcion" class="form-label">Descripción:</label>
        <textarea v-model="sala.descripcion" class="form-control" id="descripcion"></textarea>
      </div>

      <button type="submit" class="btn btn-primary">Guardar</button>
    </form>
  </div>
</template>

<script>
import 'bootstrap/dist/css/bootstrap.min.css'; // Importa el archivo de estilo Bootstrap
import axios from '@/axios';

export default {
  props: {
    club_id: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      sala: {
        nombre: '',
        descripcion: '',
        tipo: null,
        // Otros campos relacionados con la sala de cultivo
      },
      club: null, // Inicializar `club` como `null` para evitar el error
      clubActual:this.$store.getters.getClubActual,
      tiposSalas:null,
    };
  },
  async created() {
    try {
      const response = await axios.get(`/api/clubes/${this.club_id}`);
      this.club = response.data; // Asigna los datos del club cuando estén disponibles
      this.sala.club_id = this.club_id;

      const responseTiposSalas = await axios.get('/api/constantes/tipos_salas');
      this.tiposSalas = responseTiposSalas.data;
    } catch (error) {
      console.error('Error al obtener los detalles del club:', error);
    }
  },
  methods: {
    async submitForm() {
      try {
        await axios.post('/api/salasDeCultivo', {form:this.sala, club_id: this.club_id});
        alert('Sala de cultivo creada con éxito');
        this.$emit('salaCreada', this.sala);
      } catch (error) {
        console.error('Error al crear la sala de cultivo:', error);
      }
    },
  },
};
</script>

<style scoped>
/* Estilos específicos para este componente si es necesario */
</style>
